import { Fragment } from 'react';

import { HookFormResolver, InformationBlock } from '@dec/shared';
import { Row } from '@dec/shared';
import { label } from 'app/modules/Reports/TaxReturnList/translation';
import { type TaxReturn } from 'app/modules/Reports/TaxReturnList/types';
import {
  Calendar,
  Calendar3Event,
  Check2Square,
  Icon123,
  Info,
  Lightbulb,
  PersonVcard,
  TypeItalic
} from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import DateParser from 'utils/date';

export const GeneralPreview = ({ taxreturn }: { taxreturn: TaxReturn }) => {
  const { t, i18n } = useTranslation();
  return (
    <>
      <HookFormResolver onSubmit={() => {}}>
        {() => {
          return (
            <Fragment>
              <div className="card mb-5">
                <div className="card-body mx-3">
                  <Row>
                    <div className="col-md-6 col-lg-4">
                      <InformationBlock
                        title={t('config.tinLegend')}
                        value={taxreturn?.taxReturnNumber}
                        icon={Icon123}
                      />
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <InformationBlock
                        title={label(t, 'name')}
                        value={taxreturn?.taxpayer?.name}
                        icon={TypeItalic}
                      />
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <InformationBlock
                        title={t('config.tin')}
                        value={taxreturn?.taxpayer?.tin}
                        icon={PersonVcard}
                      />
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <InformationBlock
                        title={label(t, 'createDate')}
                        value={DateParser.toString(taxreturn?.createdDate)}
                        icon={Calendar}
                      />
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <InformationBlock
                        title={label(t, 'taxreturnType')}
                        value={t(`common.taxreturn-types.${taxreturn?.taxReturnType}`)}
                        icon={Info}
                      />
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <InformationBlock
                        title={label(t, 'taxreturnStatus')}
                        value={t(`common.taxreturn-status.${taxreturn?.taxReturnStatus}`)}
                        icon={Check2Square}
                      />
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <InformationBlock
                        title={label(t, 'formId')}
                        value={taxreturn?.formVersion?.form?.code?.toString()}
                        icon={Info}
                      />
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <InformationBlock
                        title={label(t, 'active')}
                        value={t(`common.yes-no.${taxreturn?.active ? 'yes' : 'no'}`)}
                        icon={Lightbulb}
                      />
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <InformationBlock
                        title={label(t, 'period')}
                        value={taxreturn?.period.toString()}
                        icon={Calendar3Event}
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </Fragment>
          );
        }}
      </HookFormResolver>
    </>
  );
};
